import NGPage from "../../generators/NGPage";
import NGReference from "../../generators/NGReference";
import { Layout } from "../../gql/graphql";
import { INGDrawerProps } from "../../library/NGFieldExtensions";
import { Box, Drawer as MUIDrawer } from "@mui/material";
import { getClassNameFromString, getsxObject } from "../../library/utils";
import { setupLocalState, updateItemContext } from "../../library/dataService";
import { useSignal } from "@preact/signals-react/runtime";
import { Anchor, Style } from "@mui/icons-material";
import { isNil } from "lodash";
import { log } from "../../library/logger";
import { isLayout } from "../../library/metadataUtils";
import NGLayoutItem from "../../generators/NGLayoutItem";
import NGLayout from "../../layouts/NGLayout";

const tag = "NGDrawer";

export default function NGDrawer({ config, context }: INGDrawerProps) {
  const currentContext = updateItemContext(context, config);
  const local = setupLocalState(
    config,
    {
      Open: useSignal(config.Open ?? false),
      OnClose: null,
      Items: useSignal(config.Items ?? []),
      Style: useSignal(config.Style ?? {}),
      Anchor: useSignal(config.Anchor ?? "left"),
    },
    currentContext
  );

  return (
    <>
      <MUIDrawer
        sx={getsxObject(local.Style.value, {
          flexShrink: 0,
          zIndex: 1300,
          [`& .MuiDrawer-paper`]: {
            width: config.Width,
            boxSizing: "border-box",
            height: config.Height,
            marginLeft: config.MarginLeft,
            marginRight: config.MarginRight,
            marginTop: config.MarginTop,
            marginBottom: config.MarginBottom,
          },
        })}
        onClose={(e, reason) => {
          log.debug(tag, `onClose called, reason: ${reason}`);
          local.Open.value = false;
          if (!isNil(local.OnClose)) local.OnClose(e, reason);
        }}
        className={getClassNameFromString(config.Classes)}
        anchor={local.Anchor.value as any}
        hideBackdrop={config.HideBackdrop as boolean}
        open={local.Open.value as boolean}
        transitionDuration={config.TransitionDuration as any}
        variant={config.Variant as any}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
      >
        {config.Content?.__typename == "Page" && (
          <NGPage config={config.Content} layout={config.Content.Layout as Layout} context={currentContext} />
        )}
        {config.ComponentName && (
          <NGReference
            config={
              {
                __typename: "Reference",
                Id: config.Id + "_ref",
                ReferenceType: "Component",
                ReferenceId: config.ComponentName,
              } as any
            }
            context={currentContext}
          />
        )}
        {local.Items.value?.map((item) => {
          if (isNil(item)) {
            log.error(tag, `Item with id '${item}' could not be found`);
            return <></>;
          }
          return (
            <Box key={item.Id}>
              {!isLayout(item) ? (
                <NGLayoutItem config={item} context={currentContext} />
              ) : (
                <NGLayout layoutItem={local.LayoutItem.value} layout={item} inDesignMode={false} context={currentContext} />
              )}
            </Box>
          );
        })}
      </MUIDrawer>
    </>
  );
}
